import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {
    initializeFirestore,
    enableMultiTabIndexedDbPersistence,
    CACHE_SIZE_UNLIMITED
} from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCOEYq_WqfBh7YqDdOqBLh4AQlT83BPPcU",
    authDomain: "jaher-reg-web.firebaseapp.com",
    projectId: "jaher-reg-web",
    storageBucket: "jaher-reg-web.firebasestorage.app",
    messagingSenderId: "927317209600",
    appId: "1:927317209600:web:69f208412714f11de71ee5",
    measurementId: "G-EJ7H11JMM8"
};

// Inicializar Firebase
console.log("🔥 Firebase: Inicializando...");
const app = initializeApp(firebaseConfig);

// Configurar Storage
const storage = getStorage(app);
console.log("🔥 Firebase Storage: Listo");

// Configurar Firestore CON CACHE ILIMITADO
const db = initializeFirestore(app, {
    cacheSizeBytes: CACHE_SIZE_UNLIMITED, // Cache más grande
    experimentalForceLongPolling: true, // Mejor para conexiones lentas
}, "web-reg-db");

console.log("🔥 Firebase Firestore: Inicializado con proyecto:", firebaseConfig.projectId);

// Habilitar persistencia offline
enableMultiTabIndexedDbPersistence(db)
    .then(() => {
        console.log("🔥 Firestore: Persistencia offline HABILITADA");
    })
    .catch((err) => {
        if (err.code === 'failed-precondition') {
            console.log("🔥 Firestore: Persistencia activa en otra pestaña");
        } else if (err.code === 'unimplemented') {
            console.log("🔥 Firestore: Persistencia no soportada en este navegador");
        } else {
            console.warn("🔥 Firestore: Error en persistencia:", err.code);
        }
    });

// Configurar Auth
const auth = getAuth(app);
console.log("🔥 Firebase Auth: Listo");

// Exportar todo
export { app, storage, db, auth };